module.exports = __webpack_public_path__ + "static/media/dayoungx2co.b0402c36.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/dayoungx2co.png
// module id = 462
// module chunks = 0